import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { Breadcrumb } from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import { useTranslation } from "react-i18next";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import useCrudForm from "../../../../../hooks/useCrudForm";
import { useParams } from "react-router-dom";
import { PathMutateFormTemplate } from "../commons/templates/pathMutateFormTemplate";
import { Form } from "react-bootstrap";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { useState } from "react";
import { RequiredAsterisks } from "../../../../general/modules/commons/Asterisks/requiredAsterisks";
import {
  pathFormSchema,
  warehouseNameSchema,
} from "../../domain/schemas/pathSchema";
import { PathModel } from "../../domain/models/PathModel";

export const PathMutatePage = () => {
  const { t } = useTranslation("common");

  const { id } = useParams();

  const dispatch = useAppDispatch();

  const model = useAppSelector((state) => state.crudMutate)
    .model as PathModel & {
    warehouse?: {
      id: string;
    };
  };

  const [warehouseId, setWarehouseId] = useState<string>(
    model?.warehouse?.id ?? "",
  );

  const title = model.id
    ? t("path.mutate.edit", { name: model.identifier })
    : t("path.mutate.create");

  const crud = useCrudForm({
    schema: pathFormSchema,
    prefix: "paths",
    createMutation: "upsertPath",
    updateMutation: "upsertPath",
    deleteMutation: "deletePath",
    id: id ? parseInt(id) : undefined,
    editUrl: "/paths/edit/:id",
    formTemplate: PathMutateFormTemplate,
    onBeforeSubmit: (values) => {
      return {
        ...values,
        warehouse_id: warehouseId,
      };
    },
  });

  if (Object.keys(model).length < 1 && id) return <></>;

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb></Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={t("Tire")} className="mb-3" />
          {crud.form}

          <Form.Group className="mb-3">
            <Form.Label>
              {t("Warehouse")} <RequiredAsterisks />
            </Form.Label>
            <EntitySelectField
              prefix="warehouses"
              entity="Warehouse"
              labelPrefix={"name"}
              id={"warehouses.id"}
              key={"warehouses.id"}
              name={"warehouses.id"}
              value={
                warehouseId === "" ? `${model?.warehouse?.id}` : warehouseId
              }
              onChange={(option) => {
                if (option === null) return;
                setWarehouseId((option as { value: string }).value);
              }}
              schema={warehouseNameSchema}
              limit={100}
            />
          </Form.Group>
        </Content>
        <Content md={4}>
          {crud.manageHeader}
          {crud.manage}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
